import { apiSlice } from './apiSlice';

export const invitationsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch invitations for a league
    fetchLeagueInvites: builder.query({
      query: (leagueId) => `/api/invites/${leagueId}`,
      providesTags: (result, error, leagueId) => [{ type: 'LeagueInvites', id: leagueId }],
    }),

    // Fetch invitations for an athlete
    fetchAthleteInvites: builder.query({
      query: (athleteId) => `/api/invites/athlete/${athleteId}`,
      providesTags: (result, error, athleteId) => [{ type: 'AthleteInvites', id: athleteId }],
    }),

    // Delete an invitation
    deleteInvitation: builder.mutation({
      query: (inviteId) => ({
        url: `/api/invites/${inviteId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { leagueId }) => [{ type: 'LeagueInvites', id: leagueId }],
    }),

    // Send an invite
    sendInvite: builder.mutation({
      query: (inviteData) => ({
        url: '/api/invites',
        method: 'POST',
        body: inviteData,
      }),
      invalidatesTags: (result, error, { leagueId }) => [{ type: 'LeagueInvites', id: leagueId }],
    }),

    assignUserToLeague: builder.mutation({
      query: ({ leagueId, email }) => ({
        url: '/api/invites/assign-user',
        method: 'POST',
        body: { leagueId, email },
      }),
      invalidatesTags: (result, error, { leagueId }) => [
        { type: 'LeagueInvites', id: leagueId },
        'AthleteInvites',
      ],
    }),

    // Accept an invitation
    acceptInvitation: builder.mutation({
      query: ({ id }) => ({
        url: `/api/invites/${id}/accept`,
        method: 'POST',
      }),
      invalidatesTags: ['AthleteInvites', 'LeagueInvites'],
    }),
  }),
});

export const {
  useFetchLeagueInvitesQuery,
  useFetchAthleteInvitesQuery,
  useSendInviteMutation,
  useAssignUserToLeagueMutation,
  useDeleteInvitationMutation,
  useAcceptInvitationMutation,
} = invitationsApiSlice;
